import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const HistoryTimerIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" className={props.className}>
		<path fill="#C3C3C3" d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z" opacity=".3" />
		<path
			fill="#AAA"
			fillRule="evenodd"
			d="M10 5.25a.75.75 0 0 1 .75.75v3.69l2.28 2.28a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1-.22-.53V6a.75.75 0 0 1 .75-.75Z"
			clipRule="evenodd"
		/>
	</svg>
);
